import { UserLanguage } from "@/shared/generated/ExpHubApi";

export enum UserLocaleCode {
  DE = "de",
  DE_AT = "de-AT",
  DE_CH = "de-CH",
  EN = "en-US",
  FR = "fr",
  FR_BE = "fr-BE",
  FR_CH = "fr-CH",
  IT_CH = "it-CH",
  NL = "nl",
  NL_BE = "nl-BE",
}

const userLocaleCodeByNormalizedCode: Record<string, UserLocaleCode> = {
  de: UserLocaleCode.DE,
  "de-at": UserLocaleCode.DE_AT,
  "de-ch": UserLocaleCode.DE_CH,
  en: UserLocaleCode.EN, // Needed for browserLanguageShort (e.g. en-GB) and older stored values (locale key in session storage).
  "en-us": UserLocaleCode.EN,
  fr: UserLocaleCode.FR,
  "fr-be": UserLocaleCode.FR_BE,
  "fr-ch": UserLocaleCode.FR_CH,
  "it-ch": UserLocaleCode.IT_CH,
  nl: UserLocaleCode.NL,
  "nl-nl": UserLocaleCode.NL, // The double "nl" is used by salesforce.
  "nl-be": UserLocaleCode.NL_BE,
};

// Converts API-style locale tags (e.g. en_US) to BCP-47 style (en-US)
const normalizeLocaleTag = (locale: string) => locale.replaceAll("_", "-");

// Parses unknown locale input into a supported UserLocaleCode
export const parseUserLocaleCode = (
  locale: unknown,
): UserLocaleCode | undefined => {
  if (typeof locale !== "string") return undefined;

  return (
    userLocaleCodeByNormalizedCode[normalizeLocaleTag(locale).toLowerCase()] ||
    undefined
  );
};

// Maps API/user locale values to a supported frontend locale (falls back to DE when missing, returns undefined when unsupported)
export const mapToUserLocaleCode = (
  locale: UserLanguage | string | undefined,
): UserLocaleCode | undefined => {
  if (!locale) return UserLocaleCode.DE;

  return parseUserLocaleCode(locale);
};
